import React, { useState } from 'react';
import Button from '../General/Button';
// import MediaServices from '../../services/mediaservices/MediaServices';
import AudioPlayerInput from './AudioPlayerInput';
import InputLabel from './InputLabel';
import { UploadFile } from './Types';
import { useEffectCancelled } from '@wajeez-web/components/helpers';
import { AiOutlineLink } from 'react-icons/ai';

const UploadMedia = ({
  name,
  required,
  label,
  disabled,
  onChange,
  fileTypes,
  value = '',
}: UploadFile) => {
  const InputRef = React.createRef<HTMLInputElement>();
  const [src, setSrc] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  useEffectCancelled(
    (canceller) => () => {
      // if (value) {
      //   MediaServices.getMediabyId(value, canceller).then((res) => {
      //     setSrc(res);
      //   });
      // }
    },
    [value]
  );

  const getFileview = () => {
    if (fileTypes.find((item) => item.includes('audio'))) {
      return <AudioPlayerInput value={src} />;
    } else {
      return (
        <a
          href={src}
          target="_blank"
          rel="noopener noreferrer"
          className={'flex space-s-2'}
        >
          <AiOutlineLink className="h-6 w-6" />
          <p>URL</p>
        </a>
      );
    }
  };

  return (
    <>
      <InputLabel text={label} name={name} required={required} />
      <input
        className="input"
        style={{
          display: 'none',
        }}
        accept={fileTypes.toString()}
        ref={InputRef}
        id="contained-button-file"
        type="file"
        onChange={(e) => {
          const file = e.target.files?.[0];
          const formData = new FormData();

          if (file) {
            formData.append('file', file, file.name);
            // setIsLoading(true);
            // MediaServices.uploadMedia(formData)
            //   .then((res) => {
            //     onChange(name, res.data);
            //   })
            //   .then(() => setIsLoading(false))
            //   .catch(() => setIsLoading(false));
          }
        }}
      />
      <div className="space-y-4">
        <Button
          bg={'primary'}
          disabled={disabled}
          color={'white'}
          loading={isLoading}
          title={`Upload ${label}`}
          onClick={() => {
            InputRef.current?.click();
          }}
        ></Button>
        {src && !isLoading && getFileview()}
      </div>
    </>
  );
};

export default UploadMedia;
